import React from 'react';

import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import '@hotmart/cosmos/dist/menu-item';

import './ListItem.scss';

const ListItem = ({ children, icon, iconAlt, badge, t }) => {
  return (
    <hot-menu-item class="menu-item">
      <div className="hot-application-menu__icon">
        <img src={icon} alt={t(iconAlt)} />
      </div>

      <span className="menu-item__label">
        {children} {badge}{' '}
      </span>
    </hot-menu-item>
  );
};

ListItem.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  badge: PropTypes.node,
  t: PropTypes.func
};

ListItem.defaultProps = {
  badge: null
};

export default translate('translate')(ListItem);
